<template>
  <section>
    <h5>{{ $t('DASHBOARD.REQUESTS')}}</h5>
    <b-card no-body>      

      <ledger-request-item v-for="item in items" :item="item" :small="1" :key="item.document.id"></ledger-request-item>

      <b-card-body class="text-center" v-if="items.length == 0">{{ $t('DASHBOARD.NO_REQUESTS')}}</b-card-body>

      <b-card-footer class="clickable text-center">
        <router-link :to="{ name: 'Documents.Requests' }">
          <i class="fal fa-file-edit" />
          {{$t('DASHBOARD.GOTO_REQUEST')}}
        </router-link>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
import LedgerRequestItem from "@/components/Ledger/LedgerRequestItem";
export default {
  components: {
    LedgerRequestItem
  },  
  data() {
    return {
      page: 0,
      limit: 8,
      items: [],
      totalItems: 0,
      fields: [
        {
          key: "auditDocument.name",
          label: this.$t("DASHBOARD.TABLE.REQUESTOR")
        },
        { key: "document.name", label: this.$t("DASHBOARD.TABLE.DOCUMENT") }
      ],
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getRequests: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/requests/list", {
          page: this.page,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getRequests();
  }
};
</script>
<style>
</style>
